/** @type {Styles} */
export const styles = {
  simple: {
    margin: 2,
    '&:hover': {
      backgroundColor: 'gray.0',
    },
    '.MuiSwitch-track': {
      backgroundColor: 'gray.40',
    },
    '.MuiSwitch-thumb': {
      backgroundColor: 'gray.3',
    },
    '.Mui-checked .MuiSwitch-thumb': {
      backgroundColor: 'primary.dark',
    },
    '.Mui-checked + .MuiSwitch-track': {
      backgroundColor: 'primary.dark',
      opacity: 0.48,
    },
    '.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: 'primary.dark',
      opacity: 0.48,
    },
  },
  labelReverse: { display: 'flex', flexDirection: 'row-reverse' },
  disabledLabel: {
    color: 'gray.56',
  },
  label: {
    width: 'fit-content',
    color: 'gray.80',
    '.MuiSwitch-switchBase': {
      color: 'gray.0',
    },
    '.MuiSwitch-track': {
      backgroundColor: 'gray.40',
      opacity: 1,
    },
    '.MuiSwitch-thumb': {
      backgroundColor: 'gray.3',
    },
    '.Mui-checked .MuiSwitch-thumb': {
      backgroundColor: 'primary.dark',
    },
    '.Mui-checked + .MuiSwitch-track': {
      backgroundColor: 'primary.dark',
      opacity: 0.48,
    },
    '.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: 'primary.dark',
      opacity: 0.48,
    },
  },
  labelSelected: {
    color: 'primary.main',
    fontSize: 14,
    fontWeight: 600,
    '.MuiTypography-root': { typography: 'header4' },
  },
  box: {
    margin: 0,
    backgroundColor: 'gray.0',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'gray.12',
    borderRadius: 1,
    justifyContent: 'space-between',
    paddingX: 3,
    paddingY: 2,
    color: 'gray.80',
    '&:not(.Mui-disabled):hover': {
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'gray.40',
    },
  },
  boxSelected: {
    borderWidth: 1,
    outline: '1px solid',
    outlineColor: 'primary.main',
    borderStyle: 'solid',
    borderColor: 'primary.main',
    color: 'primary.main',
    '.MuiTypography-root': { typography: 'header4' },
    '&:not(.Mui-disabled):hover': {
      outline: '1px solid',
      outlineColor: 'primary.main',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'primary.main',
      color: 'primary.main',
    },
  },
  tooltip: {
    color: 'gray.56',
    display: 'flex',
    padding: 0,
    '.MuiSvgIcon-root': { fontSize: 19.21 },
  },
  labelWrapper: {
    alignItems: 'center',
  },
  labelInfo: {
    typography: 'medium',
  },
  labelOnly: {
    typography: 'medium',
  },
}
